<template>
  <div class="chipField">
    <div class="chipField__group">
      <div class="chipField__field">
        <InputText 
          :id="props.data.id"
          v-model="tagValue"
          :disabled="props.data.disabled"
          :autocomplete="props.data.name"
          :placeholder="props.data.placeholder"
          :class="[props.data.errorMessage ? 'invalid' : 'valid', props.data.elementClasses ]" 
          @keyup.enter="addTag"
        />
      </div>

      <div class="chipField__btn">
        <Button
          :label="$t('add')"
          icon="icon icon-e-add"
          size="small"
          variant="outlined"
          severity="secondary"
          :pt-options="{
            variant: 'extra'
          }"
          @click="addTag"
        />
      </div>
    </div>

    <div
      v-if="error"
      class="p-error helper-text red-text text-left"
    >
      {{ error }}
    </div>

    <div
      v-if="tags.length"
      class="flex gap-2 mt-4"
    >
      <Chip
        v-for="(tag, index) in tags"
        :key="tag"
        :label="tag"
        removable
        @remove="removeTag(index)"
      />
    </div>
  </div>
</template>

<script setup>
import Chip from 'primevue/chip'

const { $i18n: i18n } = useNuxtApp()

const tagValue = ref('')
const error = ref('')

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* Current Tags
*/
const tags = ref(JSON.parse(JSON.stringify(props.data.formData[props.data.name])))

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Add New
*/
const addTag = () => {
  const tagsArr = tagValue.value.split(',')

  if (tagsArr?.length) {
    for (const item of tagsArr) {
      const newTag = item.trim()

      /**
      * Validation
      */
      if (props.data.additionalOptions?.validationType === 'email') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailPattern.test(newTag)) {
          error.value = i18n?.t('errorEmail')

          return
        }
      }

      /**
      * If Exists
      */
      if (tags.value.includes(newTag)) {
        tagValue.value = ''
          
        return
      }

      tags.value.push(newTag)
    }
  }

  tagValue.value = ''
  error.value = ''

  /**
  * Return
  */
  emit('returnData', tags.value)
}

/**
* Remove Tag
*/
const removeTag = (index) => {
  tags.value.splice(index, 1)

  /**
  * Return
  */
  emit('returnData', tags.value)
}

</script>

<style lang="scss" scoped>
.chipField {
  &__group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex: 0 0 calc(100% - 120px);
    width: 100%;
  }
  &__field {
    flex: 1 1 auto;
  }
  &__btn {
    flex: 0 0 auto;
    padding: 0 .5rem;
  }
}
</style>
